import { indexStudioNumbers } from '@services/queries/indexStudioNumbers/indexStudioNumbers';
import { useQuery } from 'react-query';
import { StudioNumbers } from '../StudioNumbers/StudioNumbers';

import {
  Container,
  Title,
  Divider,
  MetricDiv,
  Column,
  LogoDiv,
} from './StudioData.styles';

const StudioData = () => {
  const { data, isLoading, isError } = useQuery(['totalMetricsData'], () =>
    indexStudioNumbers(),
  );

  if (isLoading) {
    return <div />;
  }
  if (isError || !data) {
    return <div />;
  }
  return (
    <Container>
      <LogoDiv>
        <StudioNumbers />
      </LogoDiv>

      <Divider width="25px" />

      <Column>
        <MetricDiv>
          <Title className="values">{data.totalAssets}</Title>
          <Title className="labels">Assets</Title>
        </MetricDiv>

        <Divider width="4px" />

        <MetricDiv>
          <Title className="values">{data.totalManufacturers}</Title>
          <Title className="labels">Manufacturers</Title>
        </MetricDiv>
      </Column>
    </Container>
  );
};

export { StudioData };
